import React, {ReactNode, useEffect, useRef} from 'react';

import {sentryLogger} from '../sentryLogger';
import type {SentryEvent, SentryHint} from '../../Logger';
import {LoggerContext} from './LoggerContext';

interface ErrorHandlerProviderProps {
  readonly children: ReactNode;
  readonly dsn?: string;
  readonly release?: string;
  readonly environment?: string;
  readonly dist?: string;
  readonly ignoredErrors?: string[];
  readonly beforeSend?: (event: SentryEvent, hint: SentryHint) => SentryEvent | null;
}

const ErrorHandlerProvider = ({
  children,
  dsn,
  release,
  environment,
  dist,
  ignoredErrors,
  beforeSend,
}: ErrorHandlerProviderProps): React.ReactElement => {
  const logger = useRef(sentryLogger()).current;

  useEffect(() => {
    logger.init({dsn, release, environment, dist, ignoredErrors, beforeSend});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <LoggerContext.Provider value={logger}>{children}</LoggerContext.Provider>;
};

export {ErrorHandlerProvider};
